import { Outlet, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import Header from "./Header";
import AdminSidebar from "./AdminSidebar";
import UserSidebar from "./UserSidebar";
import { RoutesLink } from "../../ApiHelper/RoutesLink";

export default function Layout() {
  const userDetails = useSelector((state) => state.root.userDetails);

  return (
    <div className="main-wrapper position-relative">
      <div className="small-overlay-screen">
        <span>
          <img src="/assets/img/att-icon.gif" alt="mobile warning" />
        </span>

        <h1 className="text-uppercase fs-2 m-0">
          This platform is optimized for desktop use only.
        </h1>

        <p className="fs-5 lead m-0">
          Please switch to a laptop or download our mobile app for an optimized experience.
        </p>

        <div className="d-flex align-items-center gap-3 justify-content-center">
          <a
            href="https://play.google.com/store/apps/details?id=com.shreenath.energy&pli=1"
            className="btn btn-dark"
            target="_blank"
            rel="noreferrer"
          >
            Download App
            <svg width="18" height="18" viewBox="0 0 133 133" className="">
              <g>
                <path
                  fill="#47bcff"
                  d="m16.779 3.052 74.857 43.207 28.819 16.649c2.704 1.627 2.726 5.514.042 7.162l-.127.085-103.528 59.771-.085.042a4.176 4.176 0 0 1-3.232.359c-1.69-.507-3.022-2.049-3.022-4.056V6.728c0-2.007 1.331-3.549 3.022-4.056 1.035-.297 2.197-.233 3.254.38z"
                />
                <path
                  fill="#0bdf74"
                  d="m16.779 3.052 74.857 43.207L72.832 66.5 13.525 2.671c1.035-.296 2.197-.232 3.254.381z"
                />
                <path
                  fill="#fdba21"
                  d="m91.636 46.259 28.819 16.649c2.704 1.627 2.726 5.514.042 7.162l-.127.085-28.734 16.564L72.832 66.5z"
                />
                <path
                  fill="#fb434c"
                  d="m72.832 66.5 18.804 20.22-74.794 43.207-.085.042a4.176 4.176 0 0 1-3.232.359z"
                />
              </g>
            </svg>
          </a>
        </div>
      </div>

      <Header />

      <div className="main-content-wrapper">
        {userDetails?.type === 2 ? <AdminSidebar /> : <UserSidebar />}

        <div className="main-view-content" id="contentWrapper">
          <Outlet />

          <footer className="footer bg-white shadow-sm mt-auto" >
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 text-muted fw-light">
                © 2026 <span className="text-primary fw-semibold">Amprex Renewable Energy</span> All rights reserved.
              </p>

              <div className="d-flex align-items-center gap-4">
                <Link to={RoutesLink?.privacy_policy} className="text-decoration-none text-muted" style={{ transition: "color 0.3s" }} onMouseOver={(e) => e.target.style.color = '#007bff'} onMouseOut={(e) => e.target.style.color = 'inherit'}>
                  Privacy Policy
                </Link>
                <span className="badge bg-light text-dark fw-light px-2 py-1 shadow-sm">Version 1.3</span>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}